class Logger {
  baseStyles = ["color: #fff", "background-color: #444", "padding: 2px 4px", "border-radius: 2px", ""].join(";")

  log(msg) {
    console.log("%cLOG", this.baseStyles, msg)
  }

  ajax(msg) {
    const styles = this.baseStyles.concat(["color: #444", "background-color: #eee"].join(";"))
    console.log("%cAJAX", styles, msg)
  }

  success(msg) {
    const styles = this.baseStyles.concat(["background-color: green"].join(";"))
    console.log("%cSUCCESS", styles, msg)
  }

  warning(msg) {
    const styles = this.baseStyles.concat(["background-color: orange"].join(";"))
    console.log("%cWARNING", styles, msg)
  }

  error(msg) {
    const styles = this.baseStyles.concat(["background-color: red"].join(";"))
    console.log("%cERROR", styles, msg)
  }
}

export const logger = new Logger()
